module.exports = __webpack_public_path__ + "static/media/flux-capacitor.578748fc.svg";